module.exports = __webpack_public_path__ + "img/no-vehicle.2df49dc8.jpg";